import { render, staticRenderFns } from "./Weapons.vue?vue&type=template&id=684f3349&scoped=true&"
import script from "./Weapons.vue?vue&type=script&lang=js&"
export * from "./Weapons.vue?vue&type=script&lang=js&"
import style0 from "./Weapons.vue?vue&type=style&index=0&id=684f3349&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684f3349",
  null
  
)

export default component.exports